import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RensComplementairesDivers } from '../models/RensComplementairesDivers';

@Component({
  selector: 'app-rens-complementaires-divers',
  templateUrl: './rens-complementaires-divers.component.html'
})
export class RensComplementairesDiversComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'RensComplementairesDivers';
  @Input() parentForm: FormGroup;
  @Input() rensComplt: RensComplementairesDivers;

  constructor() {
  }

  public ngOnInit() {
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
}

